import PropTypes from 'prop-types';
import {
    OBJECT_COMMON_FACILITY_SUMMARY,
    OBJECT_COMMON_FACILITY,
    OBJECT_COMMON_RATE,
    PROPTYPE_REDEMPTION_INSTRUCTION,
} from './common';

export const OBJECT_TRANSIENT_RATE = {
    ...OBJECT_COMMON_RATE,
    isAutoExtended: PropTypes.bool.isRequired,
    hasOversizedFee: PropTypes.bool.isRequired,
};
export const PROPTYPE_TRANSIENT_RATE = PropTypes.shape(OBJECT_TRANSIENT_RATE);

export const OBJECT_TRANSIENT_FACILITY_SUMMARY = {
    ...OBJECT_COMMON_FACILITY_SUMMARY,
    selectedRate: PROPTYPE_TRANSIENT_RATE,
};

export const PROPTYPE_TRANSIENT_FACILITY_SUMMARY = PropTypes.shape(
    OBJECT_TRANSIENT_FACILITY_SUMMARY
);

export const OBJECT_TRANSIENT_FACILITY = {
    ...OBJECT_COMMON_FACILITY,
    redemptionInstructions: PropTypes.shape({
        driveUp: PropTypes.arrayOf(PROPTYPE_REDEMPTION_INSTRUCTION),
    }),
};
export const PROPTYPE_TRANSIENT_FACILITY = PropTypes.shape(
    OBJECT_TRANSIENT_FACILITY
);
